// extracted by mini-css-extract-plugin
export default {"relations__header":"lsf-relations__header","relations__title":"lsf-relations__title","relations__content":"lsf-relations__content","waiting":"lsf-waiting"};